import {Component, Input, OnInit, EventEmitter, Output, ViewChild} from '@angular/core';
import {ApiResponse, Application, ApplicationCreditFlow, CreditDecisioningReasonDialogResult, DownloadCreditorWatchReportFn, GetApplicationByIdFn, GetApplicationCreditFlowResultFn, GetCreditAuditLogFn, GetCreditWebServicesFn, RunCreditFlowFn, SelectWebServicesDialogResult, UpdateCreditStatusFn, getApplicationStage, getCompanyName, getFinanceType, getLoanAmount, GetDuplicatedApplicationsFn, DuplicatedApplication, DeleteWebServicesFn, ConfirmationDialogResult, GetUserFn, RequestMoreInformationFn, CreditApprovedDialogResult, User, isAdminOrCreditUser, CreateApplicationNoteFn, RemoveApplicationNoteByNoteIdFn, GetApplicationDscrFn, UpdateCreditOfficerFn, CreditUserListDialogResult, GetActiveCreditUsersFn, NewWebService, GetHistoricalContractsFn, GetPismoContractsFn, getApplicationCustomerName, getAssetType, getOrganisationType, primaryEntityOf, parseJSON, EquifaxConsumerReportData, CreditorWatchReportData, IndividualDirector, EquifaxFraudCheckReportData, GetLvrCalculatorValueFn, isApplicationSubmitted} from '@portal-workspace/grow-shared-library';
import {applicationToDirectors} from '../component-utils';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { Subscription, combineLatest, switchMap, of, firstValueFrom } from 'rxjs';
import { ApplicationDialogService } from '../application-dialog-component/application-dialog.service';
import { PortalHotToastService } from '../portal-hot-toast-component/hot-toast.service';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder,FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexModule } from '@angular/flex-layout';
import { MatInputModule } from '@angular/material/input';
import { CreditResultAlertsComponent } from './credit-result-alerts.component';
import { CreditResultWebServicesComponent } from './credit-result-web-services.component';
import { CreditResultHistoricalContractsComponent } from './credit-result-historical-contracts.component';
import { CreditResultPismoContractsComponent } from './credit-result-pismo-contracts.component';
import { TagBoxComponent } from '../message-box/tag-box.component';
import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';
import { CreditAuditLogComponent } from './credit-audit-log.component';
import { DatePipe } from '@angular/common';
import { CreditFlowDetailsComponent } from './credit-flow-details.component';
import { MatExpansionModule } from "@angular/material/expansion";
import { MatTooltipModule } from '@angular/material/tooltip';
import { DuplicatedApplicationsComponent } from './duplicated-applications.component';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { GetApplicationAuditLogsFn, GetNotesByApplicationIdFn, getUser, httpOptions } from '@portal-workspace/grow-ui-library';
import { AssetNotesComponent } from '../asset-listing-component/asset-notes.component';
import { ApplicationService } from 'apps/portal2/src/app/service/application.service';
import { DigitalIdService } from 'apps/portal2/src/app/service/digital-id.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { PayloadApiResponse, CreditFlowConsentBlockPayload, CreditApprovalReadiness, GetApplicationPartiesPayload, commercialEntityRoleType } from '@portal-workspace/grow-shared-library';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'credit-result',
    templateUrl: './credit-result.component.html',
    styleUrls: ['./credit-result.component.scss'],
    standalone: true,
    imports: [
      MatTableModule, 
      MatCardModule,
      MatTabsModule, 
      NgClass, 
      ExtendedModule, 
      MatCardModule,
      MatDividerModule,
      MatFormFieldModule,
      MatOptionModule,
      MatSelectModule,
      FormsModule, 
      ReactiveFormsModule,
      MatButtonModule,
      FlexModule,
      MatInputModule,
      CreditResultAlertsComponent,
      CreditResultWebServicesComponent,
      CreditResultHistoricalContractsComponent,
      CreditResultPismoContractsComponent,
      TagBoxComponent,
      LooseCurrencyPipe,
      CreditAuditLogComponent,
      DatePipe,
      CreditFlowDetailsComponent,
      MatExpansionModule,
      MatTooltipModule,
      DuplicatedApplicationsComponent,
      MessageBoxComponent,
      AssetNotesComponent,
    ]
})
export class CreditResultComponent implements OnInit {
  private static readonly LOW_DOC = 'LOW DOC';
  private static readonly FAST_DOC = 'FAST DOC';

  @Input({required: true}) application!: Application;
  @Input({required: true}) runCreditFlowFn!: RunCreditFlowFn;
  @Input({required: true}) getCreditWebServicesFn!: GetCreditWebServicesFn;
  @Input({required: true}) getApplicationCreditFlowResultFn!: GetApplicationCreditFlowResultFn;
  @Input({required: true}) downloadCreditorWatchReportFn!: DownloadCreditorWatchReportFn;
  @Input({required: true}) updateCreditStatusFn!: UpdateCreditStatusFn;
  @Input({required: true}) updateCreditOfficerFn!: UpdateCreditOfficerFn;
  @Input({required: true}) getCreditAuditLogFn!: GetCreditAuditLogFn;
  @Input({required: true}) getApplicationByIdFn!: GetApplicationByIdFn;
  @Input({required: true}) getDuplicatedApplicationsFn!: GetDuplicatedApplicationsFn;
  @Input({required: true}) deleteWebServicesFn!: DeleteWebServicesFn;
  @Input({required: true}) requestMoreInformationFn!: RequestMoreInformationFn;
  @Input({required: true}) getUserFn!: GetUserFn;
  @Input({required: true}) getApplicationAuditLogsFn!: GetApplicationAuditLogsFn;
  @Input({required: true}) getNotesByApplicationIdFn!: GetNotesByApplicationIdFn;
  @Input({required: true}) createApplicationNoteFn!: CreateApplicationNoteFn;
  @Input({required: true}) removeApplicationNoteByNoteIdFn!: RemoveApplicationNoteByNoteIdFn;
  @Input({required: true}) getApplicationDscrFn!: GetApplicationDscrFn;
  @Input({required: true}) getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  @Input({required: true}) apiUrl!: string;
  @Input({required: true}) getHistoricalContractsFn!: GetHistoricalContractsFn;
  @Input({required: true}) getPismoContractsFn!: GetPismoContractsFn;
  @Input() getLvrCalculatorValueFn?: GetLvrCalculatorValueFn;
  @Output() viewReport: EventEmitter<NewWebService> = new EventEmitter();
  @Output() clickApplicationEvent = new EventEmitter<DuplicatedApplication>;
  @Output() refreshCreditTabEvent = new EventEmitter<Application>;

  formControlReasonSelection!: FormControl<string | null>;
  formControlReason!: FormControl<string | null>;
  subscriptions: Subscription[] = [];
  webServices: NewWebService[] = [];
  // Null until the fetch resolves. Passed to the alerts and web-services children, whose ngOnChanges
  // rebuilds their rows, so the applicant column fills in when it arrives rather than staying blank.
  parties: GetApplicationPartiesPayload | null = null;
  creditFlowResult: ApplicationCreditFlow[] = [];
  duplicatedApplications: DuplicatedApplication[] = [];
  loadDuplicatedApplications: boolean = false;
  loadHistoricalContracts: boolean = false;
  loadPismoContracts: boolean = false;
  currentExposure: number | null = null;
  exposureLoading: boolean = false;
  recalculatingExposureAtSubmission: boolean = false;
  satisfactoryConduct: string | null = null;
  satisfactoryConductLoading: boolean = false;
  @ViewChild(CreditResultHistoricalContractsComponent) historicalContractsComponent!: CreditResultHistoricalContractsComponent;
  @ViewChild(CreditResultPismoContractsComponent) pismoContractsComponent!: CreditResultPismoContractsComponent;
  getApplicationStage = getApplicationStage;
  getFinanceType = getFinanceType;
  getLoanAmount = getLoanAmount;
  getCompanyName = getCompanyName;
  isAdminOrCreditUser = false;
  loggedInUser: User | null = getUser();
  creditOfficer: string = '';
  // A completed credit-flow run is the only hard prerequisite; incomplete KYC/AML does not block
  // Approve. KYB pass is reported separately and handled by an audited acknowledgement when Approve
  // is clicked.
  approvalReadiness: CreditApprovalReadiness | null = null;

  constructor(
    private applicationDialogService: ApplicationDialogService,
    private toastService: PortalHotToastService,
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    private digitalIdService: DigitalIdService,
    private httpClient: HttpClient,
    private router: Router,
  ) {
    this.formControlReasonSelection = formBuilder.control(null);
    this.formControlReason = formBuilder.control(null);
  }

  ngOnInit(): void {

    this.isAdminOrCreditUser = isAdminOrCreditUser(this.loggedInUser);
    this.subscriptions.push(
      this.getCreditWebServicesFn(this.application.ApplicationId).pipe(
        this.toastService.spinnerObservable()
      ).subscribe((webServices: NewWebService[]) => {
        this.webServices = webServices;
      })
    )

    this.subscriptions.push(
      this.digitalIdService.getApplicationPartiesFn(this.application.ApplicationId)
        .subscribe(payload => this.parties = payload)
    )

    this.subscriptions.push(
      this.getApplicationCreditFlowResultFn(this.application.ApplicationId).pipe(
        this.toastService.spinnerObservable()
      ).subscribe(creditFlowResult => {
        this.creditFlowResult = creditFlowResult;
        console.log('creditFlowResult: ', creditFlowResult);
      })
    )

    if (this.application.creditOfficerId) {
      this.subscriptions.push(
        this.getUserFn(this.application.creditOfficerId, true).pipe(
          this.toastService.spinnerObservable()
        ).subscribe(result => {
          if (result) {
            this.creditOfficer = `${result?.GivenName ?? ''} ${result?.FamilyName ?? ''}`;
          }
        })
      )
    } else if (this.application.SystemCreditStatus) {
      this.creditOfficer = `System`;
    }

    // Pre-fetch exposure and satisfactory conduct in the background without showing spinner (only for admin and credit users)
    if (this.isAdminOrCreditUser) {
      this.loadApprovalReadiness();

      // Pre-fetch exposure in the background without showing spinner
      this.exposureLoading = true;
      this.subscriptions.push(
        this.applicationService.getApplicationExposureFn(this.application.ApplicationId).subscribe({
          next: (exposure) => {
            this.currentExposure = exposure;
            this.exposureLoading = false;
          },
          error: (err) => {
            console.error('Error fetching exposure:', err);
            this.currentExposure = 0;
            this.exposureLoading = false;
          }
        })
      );

      // Pre-fetch satisfactory conduct in the background without showing spinner
      this.satisfactoryConductLoading = true;
      this.subscriptions.push(
        this.applicationService.getSatisfactoryConductFn(this.application.ApplicationId).subscribe({
          next: (conductRating) => {
            this.satisfactoryConduct = conductRating;
            this.satisfactoryConductLoading = false;
          },
          error: (err) => {
            console.error('Error fetching satisfactory conduct:', err);
            this.satisfactoryConduct = 'Satisfactory'; // Default to satisfactory on error
            this.satisfactoryConductLoading = false;
          }
        })
      );

    }
  }


  reloadApplication() {
    this.subscriptions.push(
      this.getApplicationByIdFn(this.application.ApplicationId).pipe(
        this.toastService.spinnerObservable()
      ).subscribe(application => {
        this.application = application;
      })
    )
  }

  recalculateExposureAtSubmission() {
    if (this.recalculatingExposureAtSubmission) {
      return;
    }
    this.recalculatingExposureAtSubmission = true;
    this.subscriptions.push(
      this.applicationService.recalculateExposureAtSubmissionFn(this.application.ApplicationId).pipe(
        this.toastService.spinnerObservable(),
      ).subscribe({
        next: (exposure) => {
          this.application = { ...this.application, ExposureAtSubmission: exposure };
          this.recalculatingExposureAtSubmission = false;
          this.toastService.success('Exposure at submission recalculated');
        },
        error: (err: HttpErrorResponse) => {
          this.recalculatingExposureAtSubmission = false;
          this.toastService.error(this.getApiErrorMessage(err, 'Failed to recalculate exposure at submission'));
        }
      })
    );
  }

  reload() {
    this.subscriptions.push(
      combineLatest([
        this.getApplicationByIdFn(this.application.ApplicationId),
        this.getCreditWebServicesFn(this.application.ApplicationId),
        this.getApplicationCreditFlowResultFn(this.application.ApplicationId)
      ]).pipe(
        this.toastService.spinnerObservable()
      ).subscribe(([application, webServices, creditFlowResult]) => {
        this.application = application;
        this.webServices = webServices;
        console.log('webServices: ', webServices);
        this.creditFlowResult = creditFlowResult;
        console.log('creditFlowResult: ', creditFlowResult);
      })
    )
    if (this.isAdminOrCreditUser) {
      this.loadApprovalReadiness();
    }
  }

  // Background fetch (no spinner); a failed check leaves approvalReadiness null, which keeps
  // Approve disabled rather than allowing an approval that may not meet the readiness rules.
  private loadApprovalReadiness() {
    this.subscriptions.push(
      this.applicationService.getCreditApprovalReadinessFn(this.application.ApplicationId).subscribe({
        next: (readiness) => {
          this.approvalReadiness = readiness;
        },
        error: () => {
          this.approvalReadiness = null;
        }
      })
    );
  }

  // Replaces the flow-status message box when the latest result came from a run that found a human
  // credit officer already assigned: that run only recommends, so the officer is asked to review.
  get creditOfficerRerunDecision(): string | null {
    const latest = this.creditFlowResult[this.creditFlowResult.length - 1];
    if (!this.application.creditOfficerId || !latest?.flow?.some(node => node.creditOfficerAssignedRerun)) {
      return null;
    }
    const decisions: Record<string, string> = { Approved: 'Approve', Declined: 'Decline', Refer: 'Refer' };
    const status = this.application.SystemCreditStatus ?? '';
    return decisions[status] ?? status;
  }

  get notSubmitted(): boolean {
    return !isApplicationSubmitted(this.application);
  }

  get approveDisabled(): boolean {
    return this.notSubmitted || !this.approvalReadiness?.ready;
  }

  get approveDisabledTooltip(): string {
    if (!this.approveDisabled) {
      return '';
    }
    if (this.notSubmitted) {
      return 'Application has not been submitted';
    }
    if (!this.approvalReadiness) {
      return 'Checking approval readiness...';
    }
    const reasons: string[] = [];
    if (!this.approvalReadiness.creditFlowRun) {
      reasons.push('credit flow must run at least once');
    }
    return reasons.length ? `Approval unavailable: ${reasons.join(', ')}` : '';
  }

  runCreditFlow() {
    // Privacy-consent gate (US-10): check consent before showing the web-services dialog so a
    // blocked application surfaces the consent-required popup first rather than after selection.
    this.subscriptions.push(
      this.applicationService.checkCreditFlowConsentBlockFn(this.application.ApplicationId).pipe(
        this.toastService.spinnerObservable()
      ).subscribe({
        next: (consentBlock) => {
          if (consentBlock?.consentBlocked) {
            this.openCreditConsentRequiredDialog(consentBlock);
            return;
          }
          this.openSelectWebServicesDialogAndRun();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(this.getApiErrorMessage(error, 'Failed to verify privacy consent'));
        }
      })
    );
  }

  private openSelectWebServicesDialogAndRun() {
    this.subscriptions.push(
      this.applicationDialogService.openSelectWebServicesDialog({
        webServices: this.webServices,
        application: this.application,
        parties: this.parties,
        productType: this.isAssetFinanceApplication()
          ? (this.toDisplayProductType(this.currentProductTypeValue()) as 'LOW DOC' | 'EASY DOC' | 'FULL DOC')
          : undefined
      }).afterClosed().subscribe((dialogResult: SelectWebServicesDialogResult | undefined) => {
        if (!dialogResult?.readyForSubmission) {
          return;
        }

        const selectedWebServiceIds = dialogResult.webServiceIds ?? [];
        const previousProductType = this.currentProductTypeValue();
        const selectedProductType = dialogResult.productType ?? this.toDisplayProductType(previousProductType);
        const nextProductType = this.toStoredProductType(selectedProductType);
        const runProductType = this.isAssetFinanceApplication() ? nextProductType : undefined;
        const preRun$ = selectedWebServiceIds.length
          ? this.deleteWebServicesFn(selectedWebServiceIds.map(id => Number(id))).pipe(
              switchMap(() => of(null))
            )
          : of(null);

        this.subscriptions.push(
          preRun$.pipe(
            switchMap(() => this.runCreditFlowFn(this.application.ApplicationId, false, runProductType)),
            this.toastService.spinnerObservable()
          ).subscribe({
            next: (result) => {
              if (result.status) {
                this.applicationDialogService.successDialog({
                  message: 'Success',
                  subMessage: result.message
                }).afterClosed().subscribe(() => {
                  this.reload();
                });
              } else if (this.handleConsentBlocked(result)) {
                // consent-required popup shown; nothing further to do here
              } else {
                this.applicationDialogService.openAlertDialog({
                  message: 'Alert',
                  subMessage: result.message
                }).afterClosed().subscribe();
              }
            },
            error: (error: HttpErrorResponse) => {
              this.toastService.error(this.getApiErrorMessage(error, 'Failed to run credit flow'));
            }
          })
        );
      })
    );
  }

  resumeCreditFlow() {
    this.subscriptions.push(
      this.applicationDialogService.openConfirmationDialog({
        message: "Resume Credit Flow",
        subMessage: "This action will resume the credit flow from the point it failed last time. Are you sure to continue?"
      }).afterClosed().subscribe((result) => {
        if (result?.readyForSubmission) {
          this.runCreditFlowFn(this.application.ApplicationId, true).pipe(
            this.toastService.spinnerObservable()
          ).subscribe(result => {
            if (result.status) {
              this.applicationDialogService.successDialog({
                message: 'Success',
                subMessage: result.message
              }).afterClosed().subscribe(() => {
                this.reload();
              })
            } else if (this.handleConsentBlocked(result)) {
              // consent-required popup shown; nothing further to do here
            } else {
              this.applicationDialogService.openAlertDialog({
                message: 'Alert',
                subMessage: result.message
              }).afterClosed().subscribe()
            }
          })
        }
      })
    )
  }

  // When runCreditFlow is blocked because an individual lacks a valid privacy consent (US-10), show the
  // consent-required popup (invalid individuals + dispatch state + Send/Resend) instead of a generic
  // alert. Returns true when the block was handled here.
  private handleConsentBlocked(result: ApiResponse): boolean {
    const payload = (result as PayloadApiResponse<CreditFlowConsentBlockPayload>).payload;
    if (!payload?.consentBlocked) {
      return false;
    }
    this.openCreditConsentRequiredDialog(payload);
    return true;
  }

  private openCreditConsentRequiredDialog(payload: CreditFlowConsentBlockPayload): void {
    this.applicationDialogService.openCreditConsentRequiredDialog({
      individuals: payload.individuals,
      resendFn: (individualId: string) => this.digitalIdService.reissueConsentForm(this.application.ApplicationId, individualId),
    }).afterClosed().subscribe(() => {
      this.reload();
    });
  }

  openDuplicatedApplications() {
    if (!this.loadDuplicatedApplications) {
      this.subscriptions.push(
        this.getDuplicatedApplicationsFn(this.application.ApplicationId).pipe(
          this.toastService.spinnerObservable()
        ).subscribe(duplicatedApplications => {
          this.duplicatedApplications = duplicatedApplications;
          this.loadDuplicatedApplications = true;
          console.log('duplicatedApplications: ', duplicatedApplications);
        })
      )
    }
  }

  openHistoricalContracts() {
    if (!this.loadHistoricalContracts && this.historicalContractsComponent) {
      this.loadHistoricalContracts = true;
      this.historicalContractsComponent.loadContracts();
    }
  }

  openPismoContracts() {
    if (!this.loadPismoContracts && this.pismoContractsComponent) {
      this.loadPismoContracts = true;
      this.pismoContractsComponent.loadContracts();
    }
  }

  onClickPismoAccount(accountNumber: number) {
    if (!accountNumber) {
      return;
    }
    const urlTree = this.router.createUrlTree(['/s', 'pismo-account', accountNumber]);
    window.open(this.router.serializeUrl(urlTree), '_blank');
  }

  async onCreditApprove() {
    let kybRiskAcknowledged = false;
    try {
      const risk = await firstValueFrom(
        this.applicationService.getKybRiskStatusFn(this.application.ApplicationId).pipe(
          this.toastService.spinnerObservable(),
        ),
      );
      if (risk.requiresAcknowledgement) {
        const confirmation = await firstValueFrom(
          this.applicationDialogService.openConfirmationDialog({
            message: 'Unresolved KYB risk',
            subMessage:
              `${risk.unresolvedEntityCount} business entity(ies) still have unresolved KYB or reconciliation. ` +
              'Approve credit anyway? Your acknowledgement will be recorded.',
          }).afterClosed(),
        );
        if (!confirmation?.readyForSubmission) {
          return;
        }
        kybRiskAcknowledged = true;
      }
    } catch {
      this.toastService.error('Unable to check KYB risk. Please try again.', 'Credit approval');
      return;
    }
    this.subscriptions.push(
      this.applicationDialogService.openCreditApprovedDialog({
        application: this.application,
        getApplicationDscrFn: this.getApplicationDscrFn,
        getLvrCalculatorValueFn: this.getLvrCalculatorValueFn,
      })
      .afterClosed().subscribe((result: CreditApprovedDialogResult | undefined) => {
          if (result) {
            this.updateCreditStatusFn({
              applicationId: this.application.ApplicationId,
              status: 'Approved',
              approveDetails: result,
              kybRiskAcknowledged,
            }).pipe(
              this.toastService.spinnerObservable(),
              this.toastService.snackBarObservable(`Credit Status Updated`),
            ).subscribe(() => {
              this.refreshCreditTabEvent.emit(this.application);
            })
          }
        }
      )
    )
  }

  onDecline() {
    this.subscriptions.push(
      this.applicationDialogService.openCreditDecisioningReasonsDialog({
        status: 'Declined'
      }).afterClosed().subscribe((result: CreditDecisioningReasonDialogResult | undefined) => {
          if (result && result.readyForSubmission) {
            this.updateCreditStatusFn({
              applicationId: this.application.ApplicationId,
              status: 'Declined',
              declineDetails: {
                reasonSelection: result.reasonSelection,
                reason: result.reason
              }
            }).pipe(
              this.toastService.spinnerObservable(),
              this.toastService.snackBarObservable(`Credit Status Updated`),
            ).subscribe(() => {
              this.refreshCreditTabEvent.emit(this.application);
            })
          }
        }
      )
    )
  }

  moreInformation() {
    this.subscriptions.push(
      this.applicationDialogService.openMoreInformationDialog({
        application: this.application,
        getUserFn: this.getUserFn,
        isShowRequestReviewSection: true,
        groupNames: [],
      }).afterClosed().subscribe(result => {
        if (result && result.readyForSubmission) {
          console.log('====result: ', result)
          this.requestMoreInformationFn({
            additionalInformation: result.additionalInformation,
            emailList: result.emailList,
            applicationId: this.application.ApplicationId
          }).pipe(
            this.toastService.spinnerObservable(),
            this.toastService.snackBarObservable(`Request More Information Success`),
          ).subscribe(() => {
            this.refreshCreditTabEvent.emit(this.application);
          })
        }
      })
    )
  }

  requestForBankStatements() {
    this.subscriptions.push(
      this.applicationDialogService.openConfirmationDialog({
        subMessage: "Are you sure that you want Bank Statements for this application?",
        message: 'Request Bank Statements'
      }).afterClosed().subscribe((result: ConfirmationDialogResult | undefined) => {
          if (result && result.readyForSubmission) {
            this.updateCreditStatusFn({
              applicationId: this.application.ApplicationId,
              status: "Request Bank Statements",
            }).pipe(
              this.toastService.spinnerObservable(),
              this.toastService.snackBarObservable(`Credit Status Updated`),
            ).subscribe(() => {
              this.refreshCreditTabEvent.emit(this.application);
            })
          }
        }
      )
    )
  }

  onViewReport(element: NewWebService) {
    this.viewReport.emit(element)
  }

  onClick(event: DuplicatedApplication) {
    this.clickApplicationEvent.emit(event);
  }

  takeOwnership() {
    this.subscriptions.push(
      this.applicationDialogService.openConfirmationDialog({
        subMessage: "Are you sure that you want to take ownership of this application?",
        message: 'Take Ownership'
      }).afterClosed().subscribe((result: ConfirmationDialogResult | undefined) => {
          if (result && result.readyForSubmission) {
            if (!this.loggedInUser) {
              this.toastService.error('No logged in user found');
              return;
            }
            this.updateCreditOfficerFn({
              applicationId: this.application.ApplicationId,
              creditOfficerId: this.loggedInUser.UserId
            }).pipe(
              this.toastService.spinnerObservable(),
              this.toastService.snackBarObservable(`Credit Officer Updated`),
            ).subscribe(() => {
              this.refreshCreditTabEvent.emit(this.application);
            })
          }
        }
      )
    )
  }

  assignCreditOfficer() {
    this.subscriptions.push(
      this.applicationDialogService.openCreditUserListDialog({
        getActiveCreditUsersFn: this.getActiveCreditUsersFn
      }).afterClosed().subscribe((result: CreditUserListDialogResult | undefined) => {
          if (result) {
            this.updateCreditOfficerFn({
              applicationId: this.application.ApplicationId,
              creditOfficerId: result.userId
            }).pipe(
              this.toastService.spinnerObservable(),
              this.toastService.snackBarObservable(`Credit Officer Updated`),
            ).subscribe(() => {
              this.refreshCreditTabEvent.emit(this.application);
            })
          }
        }
      )
    )
  }

  isAssetFinanceApplication(): boolean {
    return this.application.ApplicationType === 'AssetFinance';
  }

  currentProductTypeValue(): string {
    const productType = (this.application.AppInfo as any)?.productType;
    return (typeof productType === 'string' && productType.length) ? productType : CreditResultComponent.FAST_DOC;
  }

  toDisplayProductType(productType: string | null | undefined): string {
    if (!productType) return '';
    if (productType === CreditResultComponent.FAST_DOC) return CreditResultComponent.LOW_DOC;
    return productType;
  }

  toStoredProductType(productType: string | null | undefined): 'FAST DOC' | 'EASY DOC' | 'FULL DOC' {
    if (productType === CreditResultComponent.LOW_DOC) return CreditResultComponent.FAST_DOC;
    if (productType === 'EASY DOC') return 'EASY DOC';
    if (productType === 'FULL DOC') return 'FULL DOC';
    return CreditResultComponent.FAST_DOC;
  }

  private getApiErrorMessage(error: HttpErrorResponse, fallbackMessage: string): string {
    const apiErrorMessage = error?.error?.message;
    if (typeof apiErrorMessage === 'string' && apiErrorMessage.length > 0) {
      return apiErrorMessage;
    }
    if (apiErrorMessage && typeof apiErrorMessage.message === 'string' && apiErrorMessage.message.length > 0) {
      return apiErrorMessage.message;
    }
    if (typeof error?.message === 'string' && error.message.length > 0) {
      return error.message;
    }
    return fallbackMessage;
  }

  async copyApplicationSummary() {
    const isAssetFinance = this.application.ApplicationType === 'AssetFinance';
    
    // Extract values for pre-filling
    const borrowerName = getApplicationCustomerName(this.application) || '';
    const commercialEntity = primaryEntityOf(this.application.parties);
    const appInfoType = 'Type' in this.application.AppInfo ? this.application.AppInfo.Type : '';
    const isNew = appInfoType === 'New' || appInfoType === 'New Business' ? 'New' : appInfoType === 'Existing' || appInfoType === 'Existing Business' ? 'Existing' : '';
    const businessType = getOrganisationType(this.application) || commercialEntity?.entityType || '';
    const loanType = isAssetFinance ? (getFinanceType(this.application) || '') : '';
    const anzicCode = commercialEntity?.industry?.industryClass
      || (commercialEntity?.industry?.industryClassDetail as { code?: string } | null | undefined)?.code
      || '';
    const anzic = await this.getFormattedIndustryClass(anzicCode);
    const introducer = 'BrokerEntityName' in this.application.AppInfo ? (this.application.AppInfo.BrokerEntityName || '') : '';
    const amount = getLoanAmount(this.application) ? `$${getLoanAmount(this.application)?.toLocaleString('en-AU')}` : '';
    const product = 'productType' in this.application.AppInfo ? this.application.AppInfo.productType : '';
    const purpose = 'LoanPurpose' in this.application.AppInfo && this.application.AppInfo.LoanPurpose ? this.application.AppInfo.LoanPurpose.name : '';
    const assetTypeTier = isAssetFinance ? (getAssetType(this.application) || '') : '';
    const deposit = isAssetFinance && 'PricingDetails' in this.application && 'Deposit' in this.application.PricingDetails && this.application.PricingDetails.Deposit !== undefined
      ? `$${this.application.PricingDetails.Deposit.toLocaleString('en-AU')}` : '';
    const term = 'PricingDetails' in this.application && 'LoanTerm' in this.application.PricingDetails && this.application.PricingDetails.LoanTerm
      ? `${this.application.PricingDetails.LoanTerm} months` : '';
    const balloon = isAssetFinance && 'PricingDetails' in this.application && 'BalloonPayment' in this.application.PricingDetails && this.application.PricingDetails.BalloonPayment !== undefined
      ? `$${this.application.PricingDetails.BalloonPayment.toLocaleString('en-AU')}` : '';
    // Proposed Exposure will be calculated as current exposure + loan amount
    // This will be set after we fetch current exposure
    const loanAmount = getLoanAmount(this.application) || 0;
    
    // Extract data from existing webServices (Equifax and CreditorWatch reports)
    let borrowerScore = '';
    const borrowerScoreParts: string[] = [];
    const directorInfoList: Array<{fullName: string, age: string, score: string, fileAge: string, adverseRemarks: string}> = [];
    let ownership = '';
    let relatedEntities = '';
    let ffg = 'Pass';

    // Get EquifaxConsumer reports for director scores and file age
    const equifaxServices = this.webServices.filter(ws => ws.type === 'EquifaxConsumer' && ws.level === 'individual');
    const directors = applicationToDirectors(this.application);

    if (equifaxServices.length > 0) {
      equifaxServices.forEach(service => {
        if (service.json) {
          try {
            const equifaxData = parseJSON(service.json) as EquifaxConsumerReportData;
            // Extract director score
            const score = equifaxData?.['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:score-data']?.['vs:score']?.['vs:score-masterscale'];
            const scoreStr = score && score !== 9999 ? score.toString() : '';
            
            // Extract file age
            const dataBlock = equifaxData?.['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:summary-data']?.['vs:data-block'];
            let ageMonths: number | undefined;
            if (Array.isArray(dataBlock)) {
              const ageValue = dataBlock?.map(obj => obj?.['vs:characteristic']).flat(1).find(obj => obj?.['vs:variable-name'] === 'NA8902_age_fle_max')?.['vs:value']?.['#text'];
              ageMonths = typeof ageValue === 'number' ? ageValue : (typeof ageValue === 'string' ? parseInt(ageValue, 10) : undefined);
            } else {
              const ageValue = (dataBlock?.['vs:characteristic'] as any)?.flat(1)?.find((obj: any) => obj?.['vs:variable-name'] === 'NA8902_age_fle_max')?.['vs:value']?.['#text'];
              ageMonths = typeof ageValue === 'number' ? ageValue : (typeof ageValue === 'string' ? parseInt(ageValue, 10) : undefined);
            }
            
            let fileAgeStr = '';
            if (ageMonths && !isNaN(ageMonths)) {
              // Format as "X years Y months" (assuming age is in months)
              const years = Math.floor(ageMonths / 12);
              const months = Math.floor(ageMonths % 12);
              if (years > 0 && months > 0) {
                fileAgeStr = `${years} ${years === 1 ? 'year' : 'years'} ${months} ${months === 1 ? 'month' : 'months'}`;
              } else if (years > 0) {
                fileAgeStr = `${years} ${years === 1 ? 'year' : 'years'}`;
              } else if (months > 0) {
                fileAgeStr = `${months} ${months === 1 ? 'month' : 'months'}`;
              } else {
                fileAgeStr = '0 months';
              }
            }
            
            // Try to match service to director by name and DoB
            let matchedDirector: IndividualDirector | undefined = undefined;
            if (directors && directors.length > 0) {
              matchedDirector = directors.find((dir: IndividualDirector) => {
                const serviceFirstName = service.individualFirstName?.toLowerCase().trim();
                const serviceLastName = service.individualLastName?.toLowerCase().trim();
                const serviceDoB = service.individualDoB;
                
                const dirFirstName = dir.firstName?.toLowerCase().trim();
                const dirLastName = dir.lastName?.toLowerCase().trim();
                const dirDoB = dir.dob?.format('YYYY-MM-DD');
                
                const nameMatch = serviceFirstName === dirFirstName && serviceLastName === dirLastName;
                const dobMatch = serviceDoB === dirDoB;
                
                return nameMatch && dobMatch;
              });
            }
            
            // Calculate director age from DoB
            let directorAge = '';
            if (matchedDirector && matchedDirector.dob) {
              const today = new Date();
              const birthDate = matchedDirector.dob.toDate();
              let age = today.getFullYear() - birthDate.getFullYear();
              const monthDiff = today.getMonth() - birthDate.getMonth();
              if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
              }
              directorAge = age.toString();
            } else if (service.individualDoB) {
              // Fallback: calculate from service DoB if director not matched
              const birthDate = new Date(service.individualDoB);
              const today = new Date();
              let age = today.getFullYear() - birthDate.getFullYear();
              const monthDiff = today.getMonth() - birthDate.getMonth();
              if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
              }
              directorAge = age.toString();
            }
            
            // Get full name
            let fullName = '';
            if (matchedDirector) {
              const firstName = matchedDirector.firstName || '';
              const lastName = matchedDirector.lastName || '';
              fullName = `${firstName} ${lastName}`.trim();
            } else if (service.individualFirstName || service.individualLastName) {
              fullName = `${service.individualFirstName || ''} ${service.individualLastName || ''}`.trim();
            }
            
            // Check for adverse data (bankruptcy, defaults, etc.) in last 12 months
            const directorAdverseRemarks: string[] = [];
            const characteristics = equifaxData?.['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:summary-data']?.['vs:data-block'];
            if (characteristics) {
              const bankruptcyFlag = Array.isArray(characteristics) 
                ? characteristics?.map(obj => obj?.['vs:characteristic']).flat(1).find(obj => obj?.['vs:variable-name'] === 'NP8512_inslv_bkrpt')?.['vs:value']?.['#text']
                : (characteristics?.['vs:characteristic'] as any)?.flat(1)?.find((obj: any) => obj?.['vs:variable-name'] === 'NP8512_inslv_bkrpt')?.['vs:value']?.['#text'];
              if (bankruptcyFlag && Number(bankruptcyFlag) > 0) {
                directorAdverseRemarks.push('Bankruptcy');
              }

              const defaults = Array.isArray(characteristics) 
                ? characteristics?.map(obj => obj?.['vs:characteristic']).flat(1).find(obj => obj?.['vs:variable-name'] === 'NY7520_df_tcut_60_84m')?.['vs:value']?.['#text']
                : (characteristics?.['vs:characteristic'] as any)?.flat(1)?.find((obj: any) => obj?.['vs:variable-name'] === 'NY7520_df_tcut_60_84m')?.['vs:value']?.['#text'];
              
              if (defaults && Number(defaults) > 0) {
                directorAdverseRemarks.push(`${Number(defaults)} payment default(s)`);
              }
            }
            
            if (fullName) {
              directorInfoList.push({
                fullName,
                age: directorAge,
                score: scoreStr,
                fileAge: fileAgeStr,
                adverseRemarks: directorAdverseRemarks.join('; ')
              });
            }
          } catch (e) {
            console.error('Error parsing EquifaxConsumer data:', e);
          }
        }
      });
    }

    // Get EquifaxFraudCheck reports for FFG (Fraud Flag)
    const equifaxFraudCheckServices = this.webServices.filter(ws => ws.type === 'EquifaxFraudCheck' && ws.level === 'individual');
    if (equifaxFraudCheckServices.length > 0) {
      let hasFraudMatch = false;
      
      equifaxFraudCheckServices.forEach(service => {
        if (service.json) {
          try {
            const fraudCheckData = parseJSON(service.json) as EquifaxFraudCheckReportData;
            const fraudCheckResults = fraudCheckData?.responseData?.productData?.fraudCheckReport?.fraudCheckResults;
            
            if (fraudCheckResults && Array.isArray(fraudCheckResults)) {
              const matches = fraudCheckResults.filter((obj: any) => {
                const matchAssessment = obj?.fraudCheckResultDetails?.matchAssessment;
                return matchAssessment === 'POSSIBLE' || matchAssessment === 'SUSPICIOUS' || matchAssessment === 'HIGHLY_SUSPICIOUS';
              });
              
              if (matches.length > 0) {
                hasFraudMatch = true;
              }
            }
          } catch (e) {
            console.error('Error parsing EquifaxFraudCheck data:', e);
          }
        }
      });
      
      if (hasFraudMatch) {
        ffg = 'Referred to credit team for further assessment';
      }
    }

    // Get ownership structure from CreditorWatch report shareInterests
    const primaryEntity = primaryEntityOf(this.application.parties);
    const creditorWatchServiceForOwnership = this.webServices.find(ws => ws.type === 'CreditorWatch' && ws.level === 'entity');
    if (primaryEntity && creditorWatchServiceForOwnership && creditorWatchServiceForOwnership.json) {
      try {
        const creditorWatchData = parseJSON(creditorWatchServiceForOwnership.json) as CreditorWatchReportData;
        const shareCapitalGroup = (creditorWatchData as any)?.organisationExtract?.shareCapitalGroup;
        const shareInterests = (creditorWatchData as any)?.organisationExtract?.shareInterests;
        
        if (shareCapitalGroup && Array.isArray(shareCapitalGroup) && shareCapitalGroup.length > 0 && shareInterests && Array.isArray(shareInterests)) {
          // Get total shares from the first share capital group
          const totalShares = shareCapitalGroup.reduce((sum: number, group: any) => {
            const shares = typeof group?.numberOfShares === 'number' ? group.numberOfShares : parseFloat(group?.numberOfShares) || 0;
            return sum + shares;
          }, 0);
          if (totalShares && totalShares > 0) {
            const ownershipParts: string[] = [];
            
            // Process each share interest
            shareInterests.forEach((shareInterest: any) => {
              const numberHeld = shareInterest?.numberHeld;
              const members = shareInterest?.members;
              const beneficiallyOwned = shareInterest?.beneficiallyOwned;
              
              if (numberHeld && members && Array.isArray(members) && members.length > 0) {
                // Calculate percentage
                const percentage = ((parseFloat(String(numberHeld)) / parseFloat(String(totalShares))) * 100).toFixed(1);
                
                // Determine beneficial ownership status
                const ownershipStatus = beneficiallyOwned ? 'beneficial' : 'non-beneficial';
                
                // Process each member in this share interest
                members.forEach((member: any) => {
                  const givenName = member?.givenName1 || member?.givenName || '';
                  const familyName = member?.familyName || '';
                  if (givenName || familyName) {
                    const name = `${givenName} ${familyName}`.trim();
                    ownershipParts.push(`${name} (${percentage}% ${ownershipStatus})`);
                  }
                });
              }
            });
            
            if (ownershipParts.length > 0) {
              ownership = ownershipParts.join(', ');
            }
          }
        }
      } catch (e) {
        console.error('Error parsing CreditorWatch data for ownership:', e);
      }
    }
    
    // Fallback: use Individuals with Shareholder role if CreditorWatch data not available
    if (!ownership) {
      // Reads the shareholder flag rather than the legacy Role string, which held one role only and so
      // filed a director who is also a shareholder as a director alone - dropping them from this list.
      const shareholders = this.parties?.individuals.filter(
        ind => ind.roles.some(role => role.isShareholder),
      ) || [];
      if (shareholders.length > 0) {
        const ownershipParts = shareholders.map(ind => {
          const name = `${ind.givenName} ${ind.surname}`;
          // Check if there's a percentage field (may be in a different structure)
          const percentage = (ind as any)?.ShareholdingPercentage || (ind as any)?.Percentage || '';
          return percentage ? `${name} (${percentage}%)` : name;
        });
        ownership = ownershipParts.join(', ');
      } else {
        // Final fallback: check if it's a company structure
        if (primaryEntity?.entityType === 'PTY') {
          ownership = 'Shareholders not specified';
        }
      }
    }

    // Get related entities from CommercialEntities (non-primary entities) with adverse remarks and scores
    const relatedEntityList: string[] = [];
    
    (this.parties?.commercialEntities ?? []).forEach(entity => {
      // Find CreditorWatch report for this entity
      const entityService = this.webServices.find(ws => 
        ws.type === 'CreditorWatch' && 
        ws.level === 'entity' && 
        (ws.ABN === entity.abn || ws.ACN === entity.acn)
      );

      if (entityService && entityService.json) {
        try {
          const entityData = parseJSON(entityService.json) as CreditorWatchReportData;
          
          // Get score for this related entity
          if (entityData?.creditScore?.currentCreditScore && entityData.creditScore.currentCreditScore !== 9999) {
            const entityType = commercialEntityRoleType(entity) || 'Unknown';
            borrowerScoreParts.push(`${entityData.creditScore.currentCreditScore.toString()} (${entityType})`);
          }
          
          const adverseItems: string[] = [];
          
          if (entityData?.creditReport?.courtJudgements && Array.isArray(entityData.creditReport.courtJudgements) && entityData.creditReport.courtJudgements.length > 0) {
            adverseItems.push(`${entityData.creditReport.courtJudgements.length} judgement(s)`);
          }
          if (entityData?.creditReport?.paymentDefaults && Array.isArray(entityData.creditReport.paymentDefaults) && entityData.creditReport.paymentDefaults.length > 0) {
            adverseItems.push(`${entityData.creditReport.paymentDefaults.length} default(s)`);
          }
          if (entityData?.creditReport?.insolvencyNotices && Array.isArray(entityData.creditReport.insolvencyNotices) && entityData.creditReport.insolvencyNotices.length > 0) {
            adverseItems.push(`${entityData.creditReport.insolvencyNotices.length} insolvency(ies)`);
          }
          
          if (adverseItems.length > 0) {
            relatedEntityList.push(`${entity.legalName || entity.tradingName || 'Unknown'} - ${adverseItems.join(', ')}`);
          } else {
            relatedEntityList.push(`${entity.legalName || entity.tradingName || 'Unknown'} (No adverse remarks)`);
          }
        } catch (e) {
          console.error('Error parsing related entity CreditorWatch data:', e);
        }
      }
    });
    
    // Combine all borrower scores (primary + related entities)
    borrowerScore = borrowerScoreParts.join(', ');
    
    relatedEntities = relatedEntityList.join('; ');

    // Get property address from individuals who own property (for security)
    let propertyAddress = '';
    const propertyOwner = this.parties?.individuals.find(ind => ind.property.isOwner && ind.property.address);
    if (propertyOwner?.property.address) {
      propertyAddress = propertyOwner.property.address.unformattedAddress || '';
    }

    // Check if there are property owners to show Security section
    const hasPropertyOwners = propertyAddress !== '';

    // Use pre-fetched exposure and satisfactory conduct if available, otherwise wait for them
    const getDataAndCopy = (exposure: number, conductRating: string) => {
      const currentExposure = exposure ? `$${exposure.toLocaleString('en-AU')}` : '$0';
      // Proposed Exposure = Current Exposure + Loan Amount (excluding deposit)
      const proposedExposureNum = exposure + loanAmount;
      const proposedExposure = `$${proposedExposureNum.toLocaleString('en-AU')}`;
      const conductWithDynaValue = conductRating;
      const abnAge = typeof this.application.CompanyDetails?.ABNAgeMonths === 'number'
        ? `${this.application.CompanyDetails.ABNAgeMonths} Months`
        : 'Unknown';
      const gstAge = typeof this.application.CompanyDetails?.GSTAgeMonths === 'number'
        ? `${this.application.CompanyDetails.GSTAgeMonths} Months`
        : 'Unknown';
      const abnAgeWithContinuity = typeof this.application.CompanyDetails?.ABNAgeMonthsWithContinuity === 'number'
        ? `${this.application.CompanyDetails.ABNAgeMonthsWithContinuity} Months`
        : abnAge;
      const gstAgeWithContinuity = typeof this.application.CompanyDetails?.GSTAgeMonthsWithContinuity === 'number'
        ? `${this.application.CompanyDetails.GSTAgeMonthsWithContinuity} Months`
        : gstAge;
      this.generateAndCopySummary(
        borrowerName, isNew, businessType, loanType, anzic, introducer, amount, product, purpose,
        assetTypeTier, deposit, term, balloon, currentExposure, proposedExposure,
        isAssetFinance, conductWithDynaValue, borrowerScore, directorInfoList,
        ownership, relatedEntities, ffg, hasPropertyOwners, propertyAddress, abnAge, gstAge,
        abnAgeWithContinuity, gstAgeWithContinuity
      );
    };

    // Check if both exposure and satisfactory conduct are ready
    const exposureReady = this.currentExposure !== null && !this.exposureLoading;
    const conductReady = this.satisfactoryConduct !== null && !this.satisfactoryConductLoading;

    if (exposureReady && conductReady && this.currentExposure !== null && this.satisfactoryConduct !== null) {
      // Both already loaded, use them immediately
      getDataAndCopy(this.currentExposure, this.satisfactoryConduct);
    } else {
      // One or both still loading, wait for them with spinner
      const exposure$ = exposureReady && this.currentExposure !== null
        ? of(this.currentExposure)
        : this.applicationService.getApplicationExposureFn(this.application.ApplicationId).pipe(
            this.toastService.spinnerObservable()
          );

      const conduct$ = conductReady && this.satisfactoryConduct !== null
        ? of(this.satisfactoryConduct)
        : this.applicationService.getSatisfactoryConductFn(this.application.ApplicationId).pipe(
            this.toastService.spinnerObservable()
          );

      this.subscriptions.push(
        combineLatest([exposure$, conduct$]).subscribe({
          next: ([exposure, conductRating]) => {
            if (!exposureReady) {
              this.currentExposure = exposure;
              this.exposureLoading = false;
            }
            if (!conductReady) {
              this.satisfactoryConduct = conductRating;
              this.satisfactoryConductLoading = false;
            }
            getDataAndCopy(exposure, conductRating);
          },
          error: (err) => {
            console.error('Error fetching exposure or satisfactory conduct:', err);
            // Use defaults on error
            getDataAndCopy(this.currentExposure ?? 0, this.satisfactoryConduct ?? 'Satisfactory');
          }
        })
      );
    }
  }

  private generateAndCopySummary(
    borrowerName: string,
    isNew: string,
    businessType: string,
    loanType: string,
    anzic: string,
    introducer: string,
    amount: string,
    product: string,
    purpose: string,
    assetTypeTier: string,
    deposit: string,
    term: string,
    balloon: string,
    currentExposure: string,
    proposedExposure: string,
    isAssetFinance: boolean,
    conductWithDyna: string,
    borrowerScore: string,
    directorInfoList: Array<{fullName: string, age: string, score: string, fileAge: string, adverseRemarks: string}>,
    ownership: string,
    relatedEntities: string,
    ffg: string,
    hasPropertyOwners: boolean,
    propertyAddress: string,
    abnAge: string,
    gstAge: string,
    abnAgeWithContinuity?: string,
    gstAgeWithContinuity?: string
  ) {
    const loanTypeLine = isAssetFinance ? `Loan Type: ${loanType}\n` : '';
    const assetTypeLine = isAssetFinance ? `Asset Type / Tier: ${assetTypeTier}\n` : '';
    const balloonLine = isAssetFinance ? `Balloon: ${balloon}\n` : '';
    const ppsrLine = isAssetFinance ? 'PPSR: Refer to system\n' : '';
    const assetDescriptionLine = isAssetFinance && 'AssetSpec' in this.application && this.application.AssetSpec?.description 
      ? `Asset Description: ${this.application.AssetSpec.description}\n` : '';
    const depositLine = isAssetFinance ? `Deposit: ${deposit}\n` : '';

    const plainText = 
`Borrower & Request

Borrower Name: ${borrowerName}
New / Existing: ${isNew}
Business Type: ${businessType}
${loanTypeLine}
ANZIC: ${anzic}
Introducer: ${introducer}
Amount: ${amount}
Product: ${product}
Purpose: ${purpose}
${assetTypeLine}
${assetDescriptionLine}
${depositLine}
Term: ${term}
${balloonLine}
Current Exposure: ${currentExposure}
Proposed Exposure: ${proposedExposure}

Profile & Bureau

Conduct with Dyna: ${conductWithDyna}
ABN Age: ${abnAge}
ABN Age (with continuity): ${abnAgeWithContinuity ?? abnAge}
GST Age: ${gstAge}
GST Age (with continuity): ${gstAgeWithContinuity ?? gstAge}
Borrower Score: ${borrowerScore}
Ownership Structure: ${ownership}
${ppsrLine}
${directorInfoList.length > 0 ? directorInfoList.map((director, index) => {
  const directorLines = [`Director ${index + 1} - ${director.fullName}`];
    directorLines.push(`    Age: ${director.age || 'Not Found'}`);
    directorLines.push(`    Director Score: ${director.score || 'Not Found'}`);
    directorLines.push(`    File Age: ${director.fileAge || 'Not Found'}`);
    directorLines.push(`    Bureau Adverse Remarks: ${director.adverseRemarks || 'None Found'}`);
  return directorLines.join('\n');
}).join('\n') : ''}
Related Entities: ${relatedEntities || 'None Found'}
FFG: ${ffg}

${hasPropertyOwners ? `Security

Property Address: ${propertyAddress}
RP Data (M/H) Date & Value: 

Address | Encumbrance | Owner | Valuation | Mortgage | Equity | LV
--------|-------------|-------|-----------|---------|--------|----
        |             |       |           |         |        |    
        |             |       |           |         |        |    
        |             |       |           |         |        |    
        |             |       |           |         |        |    
        |             |       |           |         |        |    
        |             |       | $0        | $0      | $0     | $0
` : ''} 
ATO (if applicable)

ITA Balance: 
ICA Balance: 
Payment Plan: 

Bank Statements - Observations

Balance Trends: 
Conduct: 
Notable Transactions: 
Non-Preferred Lenders: 
Income Sources: 
Main Expenses: 
Tax Payments: 

Bank Statements - Servicing

Income: 
Sales Adjustment: 
Adopted Sales: 
Debt Commitments: 
ATO Commitments: 
Dyna Commitments: 
Margin + Rationale: 
DSCR: 

Credit References

Reference Summary: 

Broker Discussion

Key Points Discussed: 





Risks & Mitigants

Key Risks: 





Key Mitigants: 





Recommendation

Outcome (Approve/Decline): 
NSCs: 
Exceptions & Rationale: `;

    const loanTypeLineHtml = isAssetFinance ? `Loan Type: ${loanType}<br>\n` : '';
    const assetTypeLineHtml = isAssetFinance ? `Asset Type / Tier: ${assetTypeTier}<br>\n` : '';
    const balloonLineHtml = isAssetFinance ? `Balloon: ${balloon}<br>\n` : '';
    const ppsrLineHtml = isAssetFinance ? 'PPSR: Refer to system<br>\n' : '';
    const assetDescriptionLineHtml = isAssetFinance && 'AssetSpec' in this.application && this.application.AssetSpec?.description 
      ? `Asset Description: ${this.application.AssetSpec.description}<br>\n` : '';
    const depositLineHtml = isAssetFinance ? `Deposit: ${deposit}<br>\n` : '';

    const htmlText = `
<b>Borrower & Request</b><br>
<br>
Borrower Name: ${borrowerName}<br>
New / Existing: ${isNew}<br>
Business Type: ${businessType}<br>
${loanTypeLineHtml}
ANZIC: ${anzic}<br>
Introducer: ${introducer}<br>
Amount: ${amount}<br>
Product: ${product}<br>
Purpose: ${purpose}<br>
${assetTypeLineHtml}
${assetDescriptionLineHtml}
${depositLineHtml}
Term: ${term}<br>
${balloonLineHtml}
Current Exposure: ${currentExposure}<br>
Proposed Exposure: ${proposedExposure}<br>
<br>
<b>Profile & Bureau</b><br>
<br>
Conduct with Dyna: ${conductWithDyna}<br>
ABN Age: ${abnAge}<br>
ABN Age (with continuity): ${abnAgeWithContinuity ?? abnAge}<br>
GST Age: ${gstAge}<br>
GST Age (with continuity): ${gstAgeWithContinuity ?? gstAge}<br>
Borrower Score: ${borrowerScore}<br>
Ownership Structure: ${ownership}<br>
${ppsrLineHtml}
${directorInfoList.length > 0 ? directorInfoList.map((director, index) => {
  const directorLines = [`Director ${index + 1} - ${director.fullName}<br>`];
    directorLines.push(`&nbsp;&nbsp;&nbsp;&nbsp;Age: ${director.age || 'Not Found'}<br>`);
    directorLines.push(`&nbsp;&nbsp;&nbsp;&nbsp;Director Score: ${director.score || 'Not Found'}<br>`);
    directorLines.push(`&nbsp;&nbsp;&nbsp;&nbsp;File Age: ${director.fileAge || 'Not Found'}<br>`);
    directorLines.push(`&nbsp;&nbsp;&nbsp;&nbsp;Bureau Adverse Remarks: ${director.adverseRemarks || 'None Found'}<br>`);
  return directorLines.join('');
}).join('') : ''}
Related Entities: ${relatedEntities || 'None Found'}<br>
FFG: ${ffg}<br>
<br>
${hasPropertyOwners ? `<b>Security</b><br>
<br>
Property Address: ${propertyAddress}<br>
RP Data (M/H) Date & Value: <br>
<br>
<table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse; width: 100%;">
<thead>
<tr>
<th>Address</th>
<th>Encumbrance</th>
<th>Owner</th>
<th>Valuation</th>
<th>Mortgage</th>
<th>Equity</th>
<th>LV</th>
</tr>
</thead>
<tbody>
<tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
<tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
<tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
<tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
<tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
</tbody>
<tfoot>
<tr>
<td></td>
<td></td>
<td></td>
<td><b>$0</b></td>
<td><b>$0</b></td>
<td><b>$0</b></td>
<td><b>$0</b></td>
</tr>
</tfoot>
</table>
<br>
` : ''}
<b>ATO (if applicable)</b><br>
<br>
ITA Balance: <br>
ICA Balance: <br>
Payment Plan: <br>
<br>
<b>Bank Statements - Observations</b><br>
<br>
Balance Trends: <br>
Conduct: <br>
Notable Transactions: <br>
Non-Preferred Lenders: <br>
Income Sources: <br>
Main Expenses: <br>
Tax Payments: <br>
<br>
<b>Bank Statements - Servicing</b><br>
<br>
Income: <br>
Sales Adjustment: <br>
Adopted Sales: <br>
Debt Commitments: <br>
ATO Commitments: <br>
Dyna Commitments: <br>
Margin + Rationale: <br>
DSCR: <br>
<br>
<b>Credit References</b><br>
<br>
Reference Summary: <br>
<br>
<b>Broker Discussion</b><br>
<br>
Key Points Discussed: <br>
<br>
<br>
<br>
<br>
<br>
<b>Risks & Mitigants</b><br>
<br>
Key Risks: <br>
<br>
<br>
<br>
<br>
<br>
Key Mitigants: <br>
<br>
<br>
<br>
<br>
<br>
<b>Recommendation</b><br>
<br>
Outcome (Approve/Decline): <br>
NSCs: <br>
Exceptions & Rationale: `;

    const clipboardItem = new ClipboardItem({
      'text/html': new Blob([htmlText.replace(/\n/g, '')], { type: 'text/html' }),
      'text/plain': new Blob([plainText], { type: 'text/plain' })
    });

    navigator.clipboard.write([clipboardItem]).then(() => {
      this.toastService.success('Application summary copied to clipboard');
    }).catch(() => {
      // Fallback to plain text if HTML clipboard fails
      navigator.clipboard.writeText(plainText).then(() => {
        this.toastService.success('Application summary copied to clipboard');
      }).catch(fallbackErr => {
        this.toastService.error('Failed to copy application summary');
        console.error('Failed to copy text: ', fallbackErr);
      });
    });
  }

  private async getFormattedIndustryClass(code: string): Promise<string> {
    if (!code) {
      return '';
    }

    try {
      const title = await firstValueFrom(
        this.httpClient.get<PayloadApiResponse<string | null>>(
          `${this.apiUrl}/industry-class/${code}`,
          httpOptions()
        ).pipe(
          map(res => res.payload),
          catchError(() => of(null))
        )
      );

      if (title) {
        return `${code} - ${title}`;
      }
      return code;
    } catch (error) {
      console.error('Error fetching industry class title:', error);
      return code;
    }
  }
}
